export default "__VITE_ASSET__CyWEPigc__"